<template>
<section id="entry-form" class="bgLGray">
  <form>
    <p class="entry-form-info" v-html="$t('MEMBER_REQUEST_CONFIRM_EXPLANATION_MESSAGE')"></p>
    <table class="tbl-entry">
      <tbody>
        <tr>
          <th>ID</th>
          <td>
            {{parent.memberId ? parent.memberId : $t('CONTACT_FORM_GUEST_TEXT')}}
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_CONFIRM_NICKNAME_LABEL')"></th>
          <td>
            {{parent.contactData.nickname}}
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_CONFIRM_NAME_LABEL')"></th>
          <td>
            {{parent.contactData.name}}
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_CONFIRM_FURIGANA_LABEL')"></th>
          <td>
            {{parent.contactData.furigana}}
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_CONFIRM_POST_CODE_LABEL')"></th>
          <td>
            {{parent.contactData.postCode}}
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_CONFIRM_ADDRESS_LABEL')"></th>
          <td>
            {{parent.contactData.address}}
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_FORM_TEL_LABEL')"></th>
          <td>
            {{parent.contactData.tel}}
          </td>
        </tr>
        <tr>
          <th v-html="$t('MEMBER_REQUEST_CONFIRM_EMAIL_LABEL')"></th>
          <td>
            {{parent.contactData.email}}
          </td>
        </tr>
        <tr v-if="parent.content">
          <th>{{$t('CONTACT_FORM_CONTACT_CONTENT_LABEL')}}</th>
          <td style="line-break: anywhere;white-space: pre-wrap;">
            {{parent.content}}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="btn-form">
      <input type="button" class="btn-back" :value="$t('MEMBER_REQUEST_CONFIRM_BACK_BUTTON_LABEL')" @click="parent.editFlag=true"><input type="button" :value="$t('MEMBER_EDIT_CONFIRM_SEND_BUTTON_LABEL')" @click="requestInquiry">
    </div>
  </form>
</section>
</template>

<script>
import Methods from '@/api/methods'
export default {
  props : {
    parent : {
      type    : Object,
      default : Object
    }
  },
  methods : {
    requestInquiry() {
      const params = {
        inquiryData      : this.parent.contactData,
        exhibitionItemNo : this.$route.name === this.$define.PAGE_NAMES.ITEM_CONTACT_PAGE_NAME ? this.$route.params.id : null,
        itemNo           : this.$route.name === this.$define.PAGE_NAMES.STOCK_CONTACT_PAGE_NAME ? this.$route.params.id : null,
        content          : this.parent.content,
        files            : this.parent.exportFiles.map(file => file.key)
      }
      this.$store.state.loading = true
      Methods.apiExcute('public/request-inquiry', this.$i18n.locale, params).then(data => {
        this.$store.state.loading = false
        this.parent.completedFlag = true
        window.scrollTo({
          top      : 0,
          left     : 0,
          behavior : 'smooth'
        })
      })
        .catch(error => {
          this.$store.state.loading = false
          this.errors = Object.assign(Methods.parseHtmlResponseError(this.$router, error), this.errors)
        })
    }
  }
}
</script>
